module.exports = __webpack_public_path__ + "img/icon_tag_health.e1187c2d.svg";